import uniqBy from 'lodash/uniqBy';
import pick from 'lodash/pick';
import sortBy from 'lodash/sortBy';
import moment from 'moment';

export const colors = ['#FF836A', '#FFAF2E', '#BEE94B', '#59E6AA', '#0DD396', '#B5B5B5'];

export const colors2 = [
  '#e57373',
  '#f06292',
  '#ba68c8',
  '#9575cd',
  '#7986cb',
  '#64b5f6',
  '#4fc3f7',
  '#4dd0e1',
  '#4db6ac',
  '#81c784',
  '#aed581',
  '#dce775',
  '#fff176',
  '#ffd54f',
  '#ffb74d',
  '#ff5722',
  '#c62828',
  '#ad1457',
  '#6a1b9a',
  '#4527a0',
  '#283593',
  '#1565c0',
  '#0277bd',
  '#00838f',
  '#00695c',
  '#2e7d32',
  '#558b2f',
  '#9e9d24',
  '#f9a825',
  '#ff8f00',
  '#ef6c00',
  '#d84315',
];

// function getProperIndex(index) {
//   for (let i = colors.length - 1; i < colors.length && i >= 0; i--) {
//     if (index % i === 0) return i;
//   }
//   const primeIndexes = colors.filter((_, i) => i % 2 !== 0);
//   const primeRests = primeIndexes.map(primeIndex => ({
//     index: primeIndex,
//     rest: index % primeIndex,
//   }));
//   return sortBy(primeRests, 'rest').index;
// }

export function getColor(index) {
  // const properIndex = getProperIndex(index);
  // return colors[properIndex];

  if (parseInt(index) <= 20) {
    return colors[0];
  }
  if (parseInt(index) >= 20 && parseInt(index) < 40) {
    return colors[1];
  }
  if (parseInt(index) >= 40 && parseInt(index) < 60) {
    return colors[2];
  }
  if (parseInt(index) >= 60 && parseInt(index) < 80) {
    return colors[3];
  }
  if (parseInt(index) >= 80 && parseInt(index) <= 110) {
    return colors[4];
  }
  return colors[5];
}

export function getColorTRI(index) {
  // const properIndex = getProperIndex(index);
  // return colors[properIndex];

  if (parseInt(index) <= 450) {
    return colors[0];
  }
  if (parseInt(index) >= 450 && parseInt(index) < 550) {
    return colors[1];
  }
  if (parseInt(index) >= 550 && parseInt(index) < 650) {
    return colors[2];
  }
  if (parseInt(index) >= 650 && parseInt(index) < 750) {
    return colors[3];
  }
  if (parseInt(index) >= 750 && parseInt(index) <= 1000) {
    return colors[4];
  }
  return colors[5];
}

export function getStudentColor(index) {
  return colors2[index];
}

export function getContracts(groups) {
  if (!groups || groups.length === 0) return [];
  const allContracts = groups.map((g) => pick(g, ['idContract', 'contractName']));
  return uniqBy(allContracts, (c) => c.idContract);
}

export function getContractOptions(groups) {
  if (!groups || groups.length === 0) return [];
  const allContracts = groups.map((g) => ({ value: g.idContract, label: g.contractName }));
  return uniqBy(allContracts, (c) => c.value);
}

export function getSchoolOptions(groups, idContract) {
  if (!groups || groups.length === 0) return [];
  const allSchools = groups
    .filter((g) => !idContract || Number(g.idContract) === Number(idContract))
    .map((g) => ({ value: g.idCSchool, label: g.schoolName }));
  return uniqBy(allSchools, (s) => s.value);
}

export function getClassOptions(groups, idCSchool) {
  if (!groups || groups.length === 0) return [];
  const allClasses = groups
    .filter((g) => !idCSchool || Number(g.idCSchool) === Number(idCSchool) || g.studentsCount > 0)
    .map((g) => ({ value: g.idCourse, label: g.levelName }));
  return uniqBy(allClasses, (c) => c.value);
}

export function getInitials(name) {
  if (!name) return '';
  const parts = name.replace(/[^\w\s]/gi, '').split(' ');
  let initials = '';
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].length > 0 && parts[i] !== '' && isNaN(parts[i]) && initials.length < 2) {
      initials += parts[i][0];
    }
  }

  initials = initials.toUpperCase();
  return initials;
}

export function getFASchoolOptions(school) {
  if (!school || school.length === 0) return [];
  const allSchools = school.map((g) => ({
    value: g.idCSchool,
    label: `${g.schoolName} - ${g.schoolCity}`,
  }));
  return uniqBy(allSchools, (s) => s.value);
}

export function getFAClassesOptions(courses) {
  if (!courses || courses.length === 0) return [];
  const allClasses = courses.map((g) => ({
    value: g.idESCourse,
    label: `${g.levelName} - ${g.courseName} - ${g.period}`,
  }));
  return uniqBy(allClasses, (s) => s.value);
}

export function getFAKnowledgeAreasOptions(catalogingKnowledge) {
  if (!catalogingKnowledge || catalogingKnowledge.length === 0) return [];
  const allCatalogingKnowledge = catalogingKnowledge.map((g) => ({
    value: g.id,
    label: g.name,
  }));
  return uniqBy(allCatalogingKnowledge, (s) => s.value);
}

export function getFACurricularComponentOptions(curricularComponent) {
  if (!curricularComponent || curricularComponent.length === 0) return [];
  const allCurricularComponent = curricularComponent.map((g) => ({
    value: g.id,
    label: g.name,
  }));
  return uniqBy(allCurricularComponent, (s) => s.value);
}

export function getFAAbilitiesOptions(ability) {
  if (!ability || ability.length === 0) return [];
  const allAbilities = ability.map((g) => ({
    value: g.id,
    label: g.name.length > 100 ? `${g.name.substring(0, 100)}...` : g.name,
  }));
  return uniqBy(allAbilities, (s) => s.value);
}

export function getFABloomsOptions(bloom) {
  if (!bloom || bloom.length === 0) return [];
  const allBlooms = bloom.map((g) => ({
    value: g.id,
    label: g.name,
  }));
  return uniqBy(allBlooms, (s) => s.value);
}

export function getFClassesOptions(courses) {
  if (!courses || courses.length === 0) return [];
  const allClasses = courses.map((g) => ({
    value: g.idCourse,
    label: `${g.levelName} - ${g.courseName} - ${g.period}`,
  }));
  return uniqBy(allClasses, (s) => s.value);
}

export function getFComponentsClassesOptions(courses) {
  if (!courses || courses.length === 0) return [];
  const allClasses = courses.map((g) => ({
    value: g.idESCourse,
    label: `${g.levelName} - ${g.courseName} - ${g.period}`,
  }));
  return uniqBy(allClasses, (s) => s.value);
}

export function getFComponentsStudentsOptions(students) {
  if (!students || students.length === 0) return [];
  const allStudents = students.map((s) => ({
    value: s.idESUser,
    label: `${s.studentName}`,
  }));
  return uniqBy(allStudents, (s) => s.value);
}

export const getYears = (groups = []) => {
  if (!groups.length) return [];
  // const currentYear = new Date().getFullYear();
  const yearGroups = uniqBy(
    groups
      .map((e) => e.year)
      .sort()
      .reverse(),
  );
  // if (!yearGroups.find((el) => el === currentYear)) {
  //   yearGroups.push(currentYear);
  //   yearGroups.sort().reverse();
  // }
  return yearGroups;
};

const accentsMap = new Map([
  ['A', 'Á|À|Ã|Â|Ä'],
  ['a', 'á|à|ã|â|ä'],
  ['E', 'É|È|Ê|Ë'],
  ['e', 'é|è|ê|ë'],
  ['I', 'Í|Ì|Î|Ï'],
  ['i', 'í|ì|î|ï'],
  ['O', 'Ó|Ò|Ô|Õ|Ö'],
  ['o', 'ó|ò|ô|õ|ö'],
  ['U', 'Ú|Ù|Û|Ü'],
  ['u', 'ú|ù|û|ü'],
  ['C', 'Ç'],
  ['c', 'ç'],
  ['N', 'Ñ'],
  ['n', 'ñ'],
  ['', '[{()}]|`'],
]);

const reducer = (acc, [key]) => acc.replace(new RegExp(accentsMap.get(key), 'g'), key);

export const removeAccents = (text) => [...accentsMap].reduce(reducer, text);

export const replaceSpacesToUnderlines = (text) => text.replaceAll(' ', '_');

export const normalizeStudentName = (text) =>
  replaceSpacesToUnderlines(removeAccents(text)).toUpperCase();
